<template>
  <div class="date-range-picker">
    <button
      :class="`timeline-btn ${activeTab === 7 ? 'active' : ''}`"
      type="button"
      data-bs-toggle="collapse"
      :data-bs-target="'#' + collapseId"
      aria-expanded="false"
      :aria-controls="collapseId"
      @click="$emit('activate')"
    >
      <b class="text-white">Custom</b>
    </button>
    <div v-if="isActive" class="backdrop" data-bs-toggle="collapse" :data-bs-target="'#' + collapseId" aria-hidden="true" @click="$emit('close')"></div>
    <div
      class="collapse date-range row mx-2"
      :class="{ show: isActive, 'date-range-active': isActive }"
      :id="collapseId"
    >
      <label>
        Start Date
        <input
          type="date"
          class="form-control"
          required
          v-model="TimeFrame.from"
          aria-label="Start date"
        />
      </label>
<!--      <label class="m-3">-->
<!--        Start Time-->
<!--        <input-->
<!--          type="time"-->
<!--          class="form-control"-->
<!--          required-->
<!--          step="60"-->
<!--          v-model="TimeFrame.fromTime"-->
<!--          aria-label="Start time"-->
<!--        />-->
<!--      </label>-->
      <label class="m-3">
        End Date
        <input
          type="date"
          class="form-control"
          required
          v-model="TimeFrame.to"
          aria-label="End date"
        />
      </label>
<!--      <label class="m-3">-->
<!--        End Time-->
<!--        <input-->
<!--          type="time"-->
<!--          class="form-control"-->
<!--          required-->
<!--          step="60"-->
<!--          v-model="TimeFrame.toTime"-->
<!--          aria-label="End time"-->
<!--        />-->
<!--      </label>-->
      <span class="d-flex justify-content-between">
        <button
          data-bs-toggle="collapse"
          :data-bs-target="'#' + collapseId"
          aria-expanded="false"
          :aria-controls="collapseId"
          class="general-btn"
          @click="selectDateRange"
        >
          Select
        </button>
        <button
          data-bs-toggle="collapse"
          :data-bs-target="'#' + collapseId"
          aria-expanded="false"
          :aria-controls="collapseId"
          class="btn btn-secondary"
          @click="$emit('close')"
        >
          Close
        </button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DateRangePicker",
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    // Unique collapse ID per instance to avoid clashes between desktop and mobile timelines
    collapseId() {
      return `collapseDate-${this._uid}`;
    }
  },
  mounted() {
    const customRange = this.$store.getters.getTimeFrame;
    const now = new Date();
    const start = new Date(now);
    start.setHours(0,0,0,0);
    // If store has normalized strings (YYYY-MM-DD HH:mm:ss), strip to date-only for <input type="date">
    const onlyDate = (s) => typeof s === 'string' ? s.slice(0, 10) : s;
    this.TimeFrame.from = customRange && customRange.from ? onlyDate(customRange.from) : toLocalDateInput(start);
    this.TimeFrame.to = customRange && customRange.to ? onlyDate(customRange.to) : toLocalDateInput(now);
    // derive times from store if present
    if (customRange && customRange.startTime) {
      const d = new Date(customRange.startTime);
      this.TimeFrame.fromTime = toLocalTimeInput(d);
    } else {
      // If startTime not present but normalized `from` includes time, use it; else default 00:00
      if (customRange && typeof customRange.from === 'string' && customRange.from.length > 10 && /\d{2}:\d{2}:\d{2}$/.test(customRange.from)) {
        const t = customRange.from.split(' ')[1];
        this.TimeFrame.fromTime = t ? t.slice(0,5) : '00:00';
      } else {
        this.TimeFrame.fromTime = '00:00';
      }
    }
    if (customRange && customRange.endTime) {
      const d2 = new Date(customRange.endTime);
      this.TimeFrame.toTime = toLocalTimeInput(d2);
    } else {
      // If endTime not present but normalized `to` includes time, use it; else default to current time
      if (customRange && typeof customRange.to === 'string' && customRange.to.length > 10 && /\d{2}:\d{2}:\d{2}$/.test(customRange.to)) {
        const t2 = customRange.to.split(' ')[1];
        this.TimeFrame.toTime = t2 ? t2.slice(0,5) : toLocalTimeInput(now);
      } else {
        this.TimeFrame.toTime = toLocalTimeInput(now);
      }
    }
  },
  data() {
    return {
      TimeFrame: { from: null, to: null, fromTime: null, toTime: null },
      activeTab: 0,
      error: ''
    };
  },
  methods: {
    selectDateRange() {
      this.error = '';
      if (!this.TimeFrame.from || !this.TimeFrame.to || !this.TimeFrame.fromTime || !this.TimeFrame.toTime) {
        return this.$emit("invalid", "Invalid Time Frame");
      }
      const startLocal = fromLocalInputs(this.TimeFrame.from, this.TimeFrame.fromTime);
      const endLocal = fromLocalInputs(this.TimeFrame.to, this.TimeFrame.toTime);
      if (!startLocal || !endLocal || endLocal < startLocal) {
        return this.$emit("invalid", "End time cannot be earlier than start time.");
      }
      const payload = {
        from: this.TimeFrame.from,
        to: this.TimeFrame.to,
        startTime: startLocal.toISOString(),
        endTime: endLocal.toISOString()
      };
      this.$store.commit("setTimeFrame", payload);
      this.$emit("select", payload);
    },
  },
};

function toLocalDateInput(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
function toLocalTimeInput(d) {
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
}
function fromLocalInputs(dateStr, timeStr) {
  if (!dateStr || !timeStr) return null;
  const [y, m, d] = dateStr.split('-').map(Number);
  const [hh, mm] = timeStr.split(':').map(Number);
  return new Date(y, m - 1, d, hh, mm, 0, 0);
}
</script>

<style scoped>
.date-range {
  padding: 10px;
  justify-content: center;
  align-items: center;
  border-radius: var(--radius-card, 5px);
}

.date-range-active {
  position: fixed;            /* detach from parent flow to avoid clipping */
  top: 70px;                  /* fixed navbar height per L⚡t‑ning spec */
  right: 16px;                /* viewport padding */
  z-index: 2100;              /* above header and most dropdowns */
  background: var(--card-bg, #fff);
  color: var(--text-primary, #0F172A);
  border: 1px solid var(--card-border, #ddd);
  border-radius: var(--radius-card, 5px);
  box-shadow: var(--card-shadow, 0 6px 18px rgba(2, 6, 23, 0.08));
  padding: 15px;
  width: 320px;               /* allow room for time inputs */
  transition: var(--transition-default, 0.3s ease all);
}

.timeline-btn {
  text-wrap: nowrap;
  padding: 10px 20px;
}

@media only screen and (max-width: 950px) {
  .timeline-btn {
    padding: 5px 20px;
  }
  .date-range-active { top: 60px; right: 8px; width: calc(100vw - 16px); }
}

/* Backdrop under the overlay */
.backdrop {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(2, 6, 23, 0.35);
  z-index: 2000; /* below panel, above page */
}
</style>
